// extracted by mini-css-extract-plugin
export var root = "_zk-0";
export var scroll = "_zk-1";
export var thumb = "_zk-3";
export var track = "_zk-2";